// // src/components/ApartmentHeroGeneral.jsx
// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FaArrowRight, FaMapMarkerAlt } from 'react-icons/fa';

// const ApartmentHeroGeneral = () => {
//   // Aapki background image
//   const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-20-01-39_rnzpbf.jpg";

//   return (
//     <section className="relative h-screen flex items-center justify-center overflow-hidden">
//       {/* Background Image with Overlay */}
//       <div 
//         className="absolute inset-0 backgroundattachment bg-cover bg-no-repeat"
//         style={{
//           backgroundImage: `url('${backgroundImage}')`,
//           backgroundPosition:"50% 50%",
//         }}
//       >
//         {/* Dark Overlay for text readability */}
//         <div className="absolute inset-0 lg:bg-black/35 bg-black/50"></div>
//       </div>

//       {/* Content */}
//       <div className="container-custom relative z-10">
//         <div className=" text-center text-white 2xl:space-y-8">

//           {/* Main Heading */}
//           <h1 className="text-5xl md:text-7xl 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
//            <span className="block"> Where Every Window</span>
//             <span className="font-bold block text-[#c9a86c] mt-2">Tells a Story</span>
            
//           </h1>

//           {/* Description */}
//           <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
//             Experience unmatched luxury in the heart of Islamabad.
//           </p>

//           {/* Location Badge */}
//           {/* <div className="flex items-center justify-center gap-2 text-gray-200 mb-10">
//             <FaMapMarkerAlt className="text-[#c9a86c]" />
//             <span>Centaurus Complex, Islamabad</span>
//           </div> */}

//           {/* CTA Buttons */}
//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <a
//               href="#apartment"
//               className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
//             >
//               <span>Browse All Apartments</span>
//               <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
//             </a>
//             <Link
//               to="/contact"
//               className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white hover:text-[#1a2b3c] transition-all duration-300"
//             >
//               Contact Us
//             </Link>
//           </div>
//         </div>
//       </div>

//       {/* Simple Scroll Indicator */}
//       {/* <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
//         <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
//           <div className="w-1 h-2 bg-[#c9a86c] rounded-full mt-2 animate-bounce"></div>
//         </div>
//       </div> */}
//     </section>
//   );
// };

// export default ApartmentHeroGeneral;













// src/components/ApartmentHeroGeneral.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaMapMarkerAlt } from 'react-icons/fa';

const ApartmentHeroGeneral = () => {
  // Aapki background image
  const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-20-01-39_rnzpbf.jpg";

  return (
    <>
      {/* SEO Meta Tags for Apartments Page */}
      <Helmet>
        <title>Luxury Apartments in Centaurus Islamabad | StayIN Serviced Apartments</title>
        <meta name="description" content="Explore premium serviced apartments in Centaurus Islamabad. Studio, 1-3 bedroom luxury suites with Faisal Mosque views. Fully furnished apartments with 5-star amenities. Book your stay today." />
        <meta name="keywords" content="luxury apartments Islamabad, serviced apartments Centaurus, Centaurus Mall apartments, Faisal Mosque view apartments, StayIN apartments, furnished suites Islamabad" />
        
        {/* Open Graph for Apartments Page */}
        <meta property="og:title" content="Luxury Apartments in Centaurus Islamabad | StayIN Serviced Apartments" />
        <meta property="og:description" content="Explore premium serviced apartments in Centaurus Islamabad with stunning Faisal Mosque views. Studio, 1-3 bedroom luxury suites available." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://stayinhospitality.com/apartments" />
        <meta property="og:image" content={backgroundImage} />
        <meta property="og:image:alt" content="Luxury serviced apartment in Centaurus Islamabad with premium interiors" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Luxury Apartments in Centaurus Islamabad | StayIN" />
        <meta name="twitter:description" content="Premium serviced apartments in Centaurus Islamabad. Studio to 3-bedroom luxury suites with Faisal Mosque views." />
      </Helmet>

      {/* Schema Markup for Apartments Collection Page */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "Luxury Serviced Apartments in Centaurus Islamabad",
          "description": "Collection of premium serviced apartments at StayIN Centaurus",
          "numberOfItems": 7,
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Studio Apartment" },
            { "@type": "ListItem", "position": 2, "name": "1 Bed Apartment Faisal Mosque" },
            { "@type": "ListItem", "position": 3, "name": "2 Bed Study Apartment" },
            { "@type": "ListItem", "position": 4, "name": "2 Bed Apartment Faisal Mosque" },
            { "@type": "ListItem", "position": 5, "name": "3 Bed Apartment Faisal Mosque" },
            { "@type": "ListItem", "position": 6, "name": "1 Bed Study Apartment Cross View" },
            { "@type": "ListItem", "position": 7, "name": "2 Bed Study Apartment Cross View" }
          ]
        })}
      </script>

      <section 
        className="relative h-screen flex items-center justify-center overflow-hidden"
        aria-label="Luxury serviced apartments in Centaurus Islamabad - StayIN"
      >
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 backgroundattachment bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url('${backgroundImage}')`,
            backgroundPosition: "50% 50%",
          }}
        >
          {/* Dark Overlay for text readability */}
          <div className="absolute inset-0 lg:bg-black/35 bg-black/50"></div>
        </div>

        {/* Content */}
        <div className="container-custom relative z-10">
          <div className="text-center text-white 2xl:space-y-8">

            {/* Main Heading */}
            <h1 className="text-5xl md:text-7xl 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
              <span className="block">Where Every Window</span>
              <span className="font-bold block text-[#c9a86c] mt-2">Tells a Story</span>
            </h1>

            {/* Description */}
            <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
              Experience unmatched luxury in the heart of Islamabad.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="#apartment"
                className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
                aria-label="Browse all luxury serviced apartments in Centaurus Islamabad"
              >
                <span>Browse All Apartments</span>
                <FaArrowRight className="group-hover:translate-x-1 transition-transform" aria-hidden="true" />
              </a>
              <Link
                to="/contact"
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white hover:text-[#1a2b3c] transition-all duration-300"
                aria-label="Contact StayIN for apartment bookings and inquiries"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ApartmentHeroGeneral;